import React from 'react';
import classNames from 'classnames';
import closeIcon from '@icons/close-black.svg';
import './FilterCloseButton.scss';

export type FilterCloseButtonProps = {
  onClick: () => void;
  large?: boolean;
  white?: boolean;
  className?: string;
};

export const FilterCloseButton = ({
  onClick,
  large,
  white,
  className
}: FilterCloseButtonProps) => {
  const classes = {
    'b-close-button': true,
    large,
    white
  };

  const handleClick = e => {
    e.preventDefault();
    e.stopPropagation();
    onClick();
  };

  const btnClass = classNames(classes, className);
  return (
    <button
      className={classNames('filter-close-button', btnClass)}
      onClick={handleClick}
      type="button"
    >
      <img src={closeIcon} alt="" className="cross-icon" />
    </button>
  );
};
